// components/Atoms/Link/Link.js
import PropTypes from 'prop-types';
import NextLink from 'next/link';

const Link = ({ href = '#', children, className = '', variant = 'base', ...props }) => {
  const isExternal = href.startsWith('http') || href.startsWith('//');

  // Only apply .base-link when you explicitly want "text link" styling
  const linkClass = variant === 'base' ? `base-link ${className}` : className;

  if (isExternal) {
    return (
      <a
        href={href}
        className={linkClass}
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <NextLink href={href} className={linkClass} {...props}>
      {children}
    </NextLink>
  );
};

Link.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['base', 'plain']), // base = blue link style, plain = inherit/no styling
};

export default Link;